var app = angular.module('leonardo');

var FormFloat = function($timeout) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      maxlength: '=ngMaxLength',
      minlength: '=ngMinlength',
      min: '@',
      max: '@',
      patternExp: '=',
      patternText: '=',
      blur: '&ngBlur',
      onSubmit: '&',
      focus: '&ngFocus',
      change: '&ngChange',
      placeholder: '@',
      label: '@',
      fractionSize: '=?',
      name:'@'
    },
    templateUrl: 'views/templates/form/form-float.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.name = scope.name || 'value';

      scope.$watch('value', function(value) {
        if (!isNull(value)) {
          var result = !isNaN(value) ? parseFloat(value) : value;
          scope.ngModelCtrl.$setViewValue(result);
        }
      });

      scope.ngModelCtrl.$render = function() {
        if (scope.ngModelCtrl.$viewValue && !isNaN(scope.ngModelCtrl.$viewValue)) {
          var comma_array = scope.ngModelCtrl.$viewValue.toString().split(',');
          if (comma_array.length > 1) {
            scope.value = parseFloat(comma_array.join('.'));
          }
          else {
            scope.value = parseFloat(scope.ngModelCtrl.$viewValue);
          }
        }
        else {
          scope.value = scope.ngModelCtrl.$viewValue;
        }
      };

      element.find('input').bind("keydown keypress", function (e) {
        if (e.keyCode !== 8) {
          if (e.keyCode === 13) {
            scope.$apply(function() {
              scope.onSubmit();
            });
            e.preventDefault();
          }
          else {
            $timeout(function() {
              if (!isNull(scope.value)) {
                if (Number(scope.value) > Number(scope.max)) {
                  e.preventDefault();
                  scope.value = scope.max;
                  scope.$apply(scope.value);
                }
                if ((Number(scope.value) < Number(scope.min))) {
                  e.preventDefault();
                  scope.value = scope.min;
                  scope.$apply(scope.value);
                }
              }
            });
          }
        }
      });

      element.find('input').bind("blur", function (e) {
        $timeout(function() {
          if (!isNull(scope.value)) {
            if(Number(scope.value) > Number(scope.max)){
              e.preventDefault();
              scope.value = scope.max
              scope.$apply(scope.value);
            }
            else if((Number(scope.value) < Number(scope.min))){
              e.preventDefault();
              scope.value = scope.min;
              scope.$apply(scope.value);
            }
          }
        });
      });

    }
  };
};

app.directive('formFloat', ['$timeout', FormFloat]);
